import styled from "styled-components";
import { motion } from "framer-motion";

export const GLA_Container = styled(motion.div)`
	min-width: 0;
	min-height: 0;
	position: relative;
	overflow: auto;
`;
